import * as React from 'react';
import PostFeed from './PostFeed';
import { getPosts } from '../helpers/apiCall.js';

export function PostArchive({ posts }) {
  const [query, setQuery] = React.useState('');

  return (
    <div>
      <div>{posts && !query && <PostFeed posts={posts} />}</div>
    </div>
  );
}
